import { styled } from 'styled-components';
import { colors } from '../../../abstracts/colors';
import { getFontSize, getFontWeight } from '../../../abstracts/typography';
import { createTransition, dontForwardProps } from '../../../util';
export const CharCount = styled.span.withConfig(dontForwardProps()).withConfig({
  componentId: "aui__sc-zxp4yk-0"
})(["margin-left:", ";justify-self:flex-start;"], ({
  textHelperPresent
}) => textHelperPresent ? '0.75rem' : 'auto');
const fieldStatusColors = {
  success: colors.successDeeper,
  warn: colors.black,
  error: colors.errorDeep,
  default: colors.neutralDeeper
};
export const getBoxShadowColor = ({
  fieldStatus,
  isFocus,
  isHover,
  disabled,
  hasContent,
  shadowColors = fieldStatusColors
}) => {
  let shadowColor = shadowColors[fieldStatus];
  if ((isFocus || isHover || hasContent && isFocus) && !disabled && fieldStatus === 'default') {
    shadowColor = colors.black;
  } else if (disabled) {
    shadowColor = colors.neutralDeep;
  }
  return shadowColor;
};
export const HelperTextWrapper = styled.div.withConfig(dontForwardProps()).withConfig({
  componentId: "aui__sc-zxp4yk-1"
})(["display:flex;justify-content:space-between;width:100%;box-sizing:border-box;font-size:", ";line-height:130%;-moz-osx-font-smoothing:grayscale;font-weight:", ";padding:0.25rem 0.75rem;background-color:transparent;color:", ";", ";"], getFontSize(1), getFontWeight('base'), getBoxShadowColor, createTransition({
  properties: ['color']
}));